import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const MainCarouselSkeleton = () => {
  return (
    <div className="carousel-wrapper">
      <div className="carousel-container">
        <div className="carousel-content">
          <div className="carousel-slider-container">
            <Skeleton height="320px" width="100%" style={{ borderRadius: "12px" }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainCarouselSkeleton;